import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Autocomplete, FormLabel, TextField } from '@mui/material';
import { FC, memo } from 'react';
import { Controller } from 'react-hook-form';
import createDeviceDialogSx from '../../../../_shared/sxStyles/Device/CreateDeviceDialogSx';
import { DeviceTypeFieldProps } from './CreateDeviceDialog.types';

const getOptionLabel = (option: string | { name: string }): string =>
  typeof option === 'string' ? option : option.name;

const isOptionEqualToValue = (
  option: { name: string },
  value: { name: string },
): boolean => option.name === value.name;

const DeviceTypeField: FC<DeviceTypeFieldProps> = memo(
  ({ control, filteredDeviceTypes, onTypeChange }) => {
    const alias = useAlias();

    return (
      <div>
        <FormLabel sx={createDeviceDialogSx.fieldLabel}>
          <FormattedAlias id='Device Type' />
        </FormLabel>

        <Controller
          name='type'
          control={control}
          render={({ field }) => {
            const selectedOption =
              filteredDeviceTypes.find((type) => type.name === field.value) ||
              null;

            return (
              <Autocomplete
                freeSolo
                options={filteredDeviceTypes}
                value={selectedOption}
                inputValue={field.value || ''}
                onInputChange={(_, newInputValue) => {
                  field.onChange(newInputValue);
                  onTypeChange();
                }}
                onChange={(_, newValue) => {
                  field.onChange(
                    typeof newValue === 'string'
                      ? newValue
                      : (newValue?.name ?? ''),
                  );
                  onTypeChange();
                }}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={isOptionEqualToValue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size='small'
                    placeholder={alias('Select or type device type...')}
                    sx={createDeviceDialogSx.deviceTypeField}
                  />
                )}
                sx={{ width: '100%' }}
              />
            );
          }}
        />
      </div>
    );
  },
);

DeviceTypeField.displayName = 'DeviceTypeField';

export default DeviceTypeField;
